module.exports = __webpack_public_path__ + "icon-192x192.png";